import React from 'react';
import { Modal, Flex } from 'antd-mobile';
import jsBridge from '@/common/plugins/cmiotHelper/js-bridge';
// import getAppVersion from '@/common/plugins/getAppVersion';
import Header from '../common/header';
import './less/index.less';

class Connecting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connectedRatio: 0,
      isLoop: true,
      linkSuccess: false,
      lightColor: '绿',
      waitLong: false, // 等待时间是否超过30s
      connectTipShow: false,
      connectTipContent: '',
      connectTipTitle: '',
    };
  }

  componentWillMount() {
    const { deviceName } = this.props.bindCameraStore;
    const deviceList = ['c11', 'c12', 'c80'];
    if (deviceList.includes(deviceName)) {
      this.setState({
        lightColor: '蓝',
      });
    }
  }

  componentDidMount() {
    this.longTimeHint();
    this.startConnect();
    setTimeout(() => {
      // 禁用安卓自带返回键
      jsBridge.send({
        f: 'FLAG_BACK_TYPE',
        tk: 'BACK_TYPE_NONE',
      });
    }, 1000);
    this.increaceRatio();
  }

  componentWillUnmount() {
    clearTimeout(this.loopRatio);
    clearInterval(this.quickloopRatio);
    const { isAndroid, wifiInfo } = this.props.bindCameraStore;
    if (isAndroid) {
      jsBridge.send({
        f: 'FLAG_BACK_TYPE',
        tk: 'BACK_TYPE_DEFAULT',
      });
    }
    if (wifiInfo.wifiType === '') {
      wifiInfo.wifiType = '无';
    }
  }

  longTimeHint = () => {
    const { cableBind, deviceName } = this.props.bindCameraStore;
    if (!cableBind && deviceName === 'c71') {
      setTimeout(() => {
        this.setState({
          waitLong: true,
        });
      }, 30000);
    }
  };

  startConnect = () => {
    const {
      cableBind, deviceMac, isSmartConfig, wifiInfo, is4GDevice,
    } = this.props.bindCameraStore;

    if (wifiInfo.wifiType === '无') {
      wifiInfo.wifiType = '';
    }
    let tk = 'ADD_CAMERA_WIRELESS_BIND_REQUEST_DH';
    let p = {
      cb: true,
    };
    if (isSmartConfig) {
      tk = 'ADD_CAMERA_SMARTCONFIG_BIND_REQUEST_DH';
      p = Object.assign({}, p, wifiInfo);
    }
    if (cableBind || is4GDevice) {
      tk = 'ADD_CAMERA_WIRED_BIND_REQUEST_DH';
      p.mac = deviceMac;
    }
    // 向app请求连接摄像机
    jsBridge.send({
      f: 'FLAG_ADD_CAMERA',
      tk,
      p,
    }).then((d) => {
      if (d && d.data && d.data.resultCode) {
        this.setState({
          isLoop: false,
        }, () => {
          clearTimeout(this.loopRatio);
          this.quickIncreaceRatio(d);
        });
      }
    });
  };
  /**
   * 点击重新绑定按钮
   * */
  reBind = () => {
    const { bindCameraStore: { setSmartConfig, deviceName }, history } = this.props;
    this.closeConnectTipShow();
    // 还原smartconfig状态
    setSmartConfig(false);
    history.push(`/reset_camera?deviceName=${deviceName}&fromH5=false`);
  };

  closeConnectTipShow = () => {
    this.setState({
      connectTipShow: false,
    });
  };

  /**
   * 去扫码添加界面
   * */
  goScan = () => {
    const { isSmartConfig } = this.props.bindCameraStore;
    if (isSmartConfig) {
      this.props.history.push('/qrcode_wifi');
    } else {
      this.props.history.push('/input_wifi');
    }
  };
  /**
   * 连接比例显示
   * */
  increaceRatio = () => {
    const limitRatio = 99;
    const timeInterval = 2000;
    if (this.state.connectedRatio < limitRatio) {
      this.setState(prevState => ({
        connectedRatio: (prevState.connectedRatio + 1),
      }));
    }
    this.loopRatio = setTimeout(() => {
      this.increaceRatio();
    }, timeInterval);
    if (!this.state.isLoop) {
      clearTimeout(this.loopRatio);
    }
  };
  /**
   * 得到APP响应后快速连接比例
   * */
  quickIncreaceRatio = (d) => {
    this.quickloopRatio = setInterval(() => {
      if (this.state.connectedRatio === 100) {
        this.setState(prevState => ({
          linkSuccess: !prevState.linkSuccess,
        }), () => {
          clearInterval(this.quickloopRatio);
          if (this.state.linkSuccess) {
            this.linkCompleted(d);
          }
        });
      } else {
        this.setState(prevState => ({
          connectedRatio: (prevState.connectedRatio + 1),
        }));
      }
    }, 30);
  };

  /**
   * 连接完成后跳转
   * 当resultCode为0或者1112时表示成功
   * 当resultCode为2或者1113时表示被其他用户绑定
   * 当resultCode为1时提示：绑定失败,
   * 当resultCode为3时提示：绑定失败，错误码：连接超时
   * 当resultCode为1114、1116、1117、1118时提示：绑定失败，错误码：XXXX
   * 当resultCode为1115为表示第三方错误，resultThirdCode有用，http://confluence.ioteams.com/pages/viewpage.action?pageId=21370350
   * */
  linkCompleted = (d) => {
    // FIXME: 暂时屏蔽
    // const appInfo = getAppVersion([4, 5, 5]);
    // 存储cameraInfo
    d.data.cameraInfo && this.props.bindCameraStore.setCameraInfo(d.data.cameraInfo);
    const resultCode = d.data.resultCode.toString();

    switch (`${resultCode}`) {
      case '0':
      case '000000':
      case '1112':
        // 4.5.2版本选择家庭组和房间
        // if (appInfo.vState) {
        //   this.props.history.replace('/set_home');
        // } else {
        //   this.props.history.replace('/connect_success');
        // }
        this.props.history.replace('/connect_success');
        break;
      case '2':
      case '1113':
        this.props.history.replace('/connect_fail?isBinded=true');
        break;
      case '1115':
        this.props.history.replace(`/connect_fail?isLocked=true&resultThirdCode=${d.data.resultThirdCode}`);
        break;
      case '3':
      case '1114':
      case '1116':
      case '1117':
      case '1118':
        this.props.history.replace(`/connect_fail?resultCode=${resultCode}`);
        break;
      default:
        this.props.history.replace('/connect_fail');
        break;
    }
  };

  /**
   * 根据不同摄像机，返回不同图片
   * */
  imgSrc = () => {
    const _deviceName = this.props.bindCameraStore.deviceName;
    if (_deviceName) {
      return require(`./images/${_deviceName}-connect.png`);
    }
    return '';
  };

  /**
   * 点击异常帮助弹出提示
   * */
  handleHelp = () => {
    const { isSpecialDevice, is4GDevice } = this.props.bindCameraStore;
    const content = (
      <div className="bind-in-trouble trouble-tips">
        <p className="title">红灯长亮</p>
        {
          is4GDevice
            ? [
              <p>1.请检查4G卡是否欠费；</p>,
              <p>2.请检查4G网络是否正常；</p>,
              <p>3.网络异常，摄像机无法链接服务器。</p>,
            ]
            : (
              <div>
                <p>
                  {'1.确保摄像机需要连接的网络是可以正常通信的；'}
                  <br />
                  {'2.网络异常，摄像机无法连接服务器'}
                </p>
                {
                  !isSpecialDevice
                  && [
                    <p className="title space">语音提示Wi-Fi密码错误</p>,
                    <p>确保输入正确的2.4G频段Wi-Fi名称和密码</p>,
                  ]
                }
              </div>
            )}
      </div>
    );
    this.setState({
      connectTipShow: true,
      connectTipTitle: '绑定遇到问题？',
      connectTipContent: content,
    });
  };


  connectMp3Src = () => {
    const { deviceName } = this.props.bindCameraStore;
    // if (deviceName === 'c52') {
    //   return `/app_h5/public/common/audio/setup_hemu_connecting_${deviceName}.mp3`;
    // }
    // return '/app_h5/public/common/audio/setup_hemu_connecting.mp3';
    switch (deviceName) {
      case 'c52':
        return `/app_h5/public/common/audio/setup_hemu_connecting_${deviceName}.mp3`;
      case 'hdc-51':
        return '/app_h5/public/common/audio/setup_hemu_connecting_hdc-51.mp3';
      case 'hdc-55':
        return '/app_h5/public/common/audio/setup_hemu_connecting_hdc-51.mp3';
      default:
        return '/app_h5/public/common/audio/setup_hemu_connecting.mp3';
    }
  };

  render() {
    const { is4GDevice, deviceName, isSpecialDevice, isSmartConfig } = this.props.bindCameraStore;
    const { connectedRatio, lightColor, waitLong, connectTipShow, connectTipContent, connectTipTitle } = this.state;
    return (
      <Flex direction="column" className="connecting-container vh-100">
        <Header noBack />
        <Flex.Item>
          <div
            className={`deviceImg_block ${deviceName === 'c71' ? 'c71-device-img-block' : ''}`}
            style={{ marginTop: this.props.bindCameraStore.specialPhone && deviceName !== 'other' && 0 }}
          >
            <div className="deviceImg_element">
              <img
                className="connecting-img"
                src={this.imgSrc()}
                alt="摄像机"
              />
            </div>
          </div>
          <div>
            <p className="connecting">{`连接 ${connectedRatio}%......`}</p>
            <p className="wait">连接过程需要大约1~2分钟</p>
            {
              !is4GDevice && <p className="wait">{`${lightColor}灯闪烁代表即将成功`}</p>
            }
          </div>
          <div className={`scan_tip ${!waitLong && 'no_visible'}`}>
            {'等待时间过长，试试'}
            <span className="scan_add" role="presentation" onClick={this.goScan}>
              {isSmartConfig ? '扫描二维码绑定' : '智能快联绑定摄像机'}
            </span>
          </div>
        </Flex.Item>
        <div className="fix_block">
          {
            deviceName === 'c80'
              ? (
                <div
                  className="tips"
                  onClick={this.handleHelp}
                  role="presentation"
                >
                  <span>重新绑定</span>
                </div>
              )
              : (
                <div
                  className="tips"
                  onClick={this.handleHelp}
                  role="presentation"
                >
                  <span>红灯长亮</span>
                  {
                    !isSpecialDevice && !is4GDevice && <span className="second">语音提示Wi-Fi密码错误</span>
                  }
                </div>
              )
          }
        </div>
        <Modal
          visible={connectTipShow}
          transparent
          maskClosable={false}
          onClose={this.closeConnectTipShow}
          title={connectTipTitle}
          footer={[{
            text: '取消',
            onPress: () => this.closeConnectTipShow(),
          }, {
            text: '重新绑定',
            onPress: () => this.reBind(),
          }]}
        >
          {connectTipContent}
        </Modal>
        <audio key="audio1" autoPlay>
          <track kind="captions" />
          <source src={this.connectMp3Src()} type="audio/mp3" />
        </audio>
      </Flex>
    );
  }
}

export default Connecting;
